import React, { useState, useEffect } from 'react';
import './index.css';
import './LanguageSwitcher.css';
import './i18n';
import { useTranslation } from 'react-i18next';
import DashboardPreview from './components/DashboardPreview';
import logo from './assets/logo2.png';
import { ChevronDown, Brain, Code, Server, Shield,  Users, ArrowRight, CheckCircle, Menu, X, Play, Download, ExternalLink, Copy, FileText, Globe, MessageCircle, Calendar, Mail, Github, Linkedin, Instagram, Phone, MapPin, Send } from 'lucide-react';

export default function AINextusLanding() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [copiedCode, setCopiedCode] = useState('');

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  const copyToClipboard = (text, type) => {
    navigator.clipboard.writeText(text);
    setCopiedCode(type);
    setTimeout(() => setCopiedCode(''), 2000);
  };

  // Dil ayarları
  const { t } = useTranslation();
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };



  const apiExample = `POST /run/yolo
Authorization: Bearer YOUR_API_KEY
Content-Type: application/json

{
  "image_base64": "<base64 encoded image>"
}`;

  const responseExample = `{
  "objects": [
    {
      "label": "person", 
      "confidence": 0.98, 
      "x": 123, 
      "y": 456
    }
  ]
}`;

  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    message: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  // Form verilerini güncelleme
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Form doğrulama
  const validateForm = () => {
    if (!formData.fullName.trim()) {
      alert('Lütfen adınızı giriniz.');
      return false;
    }
    if (!formData.email.trim() || !/\S+@\S+\.\S+/.test(formData.email)) {
      alert('Lütfen geçerli bir e-posta adresi giriniz.');
      return false;
    }
    if (!formData.message.trim()) {
      alert('Lütfen mesajınızı yazınız.');
      return false;
    }
    return true;
  };

  // Form gönderme işlemi
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    setIsLoading(true);
    setSubmitStatus(null);

    try {
      // YÖNTEMs 1: EmailJS ile doğrudan e-posta gönderme
      const response = await fetch('https://api.emailjs.com/api/v1.0/email/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          service_id: 'service_1gch3yj', // EmailJS'den alacağınız
          template_id: 'template_cfciudi', // EmailJS'den alacağınız
          user_id: 'tY7bBJnQ4bdPMLuFa', // EmailJS'den alacağınız
          template_params: {
            from_name: formData.fullName,
            from_email: formData.email,
            message: formData.message,
          }
        })
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ fullName: '', email: '', message: '' });
        alert(t('thanksMessage') || 'Mesajınız başarıyla gönderildi!');
      } else {
        throw new Error('Mesaj gönderilemedi');
      }
    } catch (error) {
      console.error('Hata:', error);
      setSubmitStatus('error');
      alert('Mesaj gönderilirken bir hata oluştu. Lütfen tekrar deneyiniz.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 text-white">
      {/* Navigation */}
      <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrollY > 100 ? 'bg-slate-900/90 backdrop-blur-md border-b border-blue-500/20' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center space-x-3">
              <img src={logo} alt="AI Nextus" className="w-12 h-12" />
              <span className="text-3xl font-bold text-white">AI Nextus</span>
              <span className="text-xs bg-blue-600 text-white px-2 py-1 rounded-full">v0.9-beta</span>
            </div>
            
            <div className="hidden md:flex space-x-8">
              <button onClick={() => scrollToSection('hero')} className="text-gray-300 hover:text-white transition-colors">{t('home')}</button>
              <button onClick={() => scrollToSection('solution')} className="text-gray-300 hover:text-white transition-colors">{t('solution')}</button>
              <button onClick={() => scrollToSection('preview')} className="text-gray-300 hover:text-white transition-colors">{t('demoInteractive')}</button>
              <button onClick={() => scrollToSection('models')} className="text-gray-300 hover:text-white transition-colors">{t('models')}</button>
              <button onClick={() => scrollToSection('api')} className="text-gray-300 hover:text-white transition-colors">API</button>
              <button onClick={() => scrollToSection('contact')} className="text-gray-300 hover:text-white transition-colors">{t('contact')}</button>

             <div className="lang-switcher">
              <button onClick={() => changeLanguage('en')} className={i18n.language === 'en' ? 'active' : ''}>
                EN
              </button>
              <button onClick={() => changeLanguage('tr')} className={i18n.language === 'tr' ? 'active' : ''}>
                TR
              </button>
            </div>

            </div>

            

            <button 
              className="md:hidden text-white"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden bg-slate-900/95 backdrop-blur-md border-t border-blue-500/20">
            <div className="px-4 py-2 space-y-2">
              <button onClick={() => scrollToSection('hero')} className="block w-full text-left py-2 text-gray-300 hover:text-white">{t('home')}</button>
              <button onClick={() => scrollToSection('solution')} className="block w-full text-left py-2 text-gray-300 hover:text-white">{t('solution')}</button>
              <button onClick={() => scrollToSection('preview')} className="block w-full text-left py-2 text-gray-300 hover:text-white">{t('demoInteractive')}</button>
              <button onClick={() => scrollToSection('models')} className="block w-full text-left py-2 text-gray-300 hover:text-white">{t('models')}</button>
              <button onClick={() => scrollToSection('api')} className="block w-full text-left py-2 text-gray-300 hover:text-white">API</button>
              <button onClick={() => scrollToSection('contact')} className="block w-full text-left py-2 text-gray-300 hover:text-white">{t('contact')}</button>
            </div>
             <div className="lang-switcher">
              <button onClick={() => changeLanguage('en')} className={i18n.language === 'en' ? 'active' : ''}>
                EN
              </button>
              <button onClick={() => changeLanguage('tr')} className={i18n.language === 'tr' ? 'active' : ''}>
                TR
              </button>
            </div>
          </div>
          
        )}
      </nav>

      {/* Hero Section */}
      <section id="hero" className="min-h-screen flex items-center justify-center relative overflow-hidden pt-20">
        <div className="absolute inset-0">
          <div className="absolute top-20 left-20 w-72 h-72 bg-blue-500/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-20 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <div className="mb-8">
            <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
              {t('slogan1')} {' '}
              <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
                {t('slogan2')}
              </span>
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-gray-300 max-w-4xl mx-auto">
              {t('slogan3')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={() => scrollToSection('contact')}
                className="bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 transform hover:scale-105 flex items-center justify-center space-x-2"
              >
                <Calendar className="w-5 h-5" />
                <span>{t('requestDemo')}</span>
              </button>
              <button 
                onClick={() => scrollToSection('api')}
                className="border-2 border-blue-500 hover:bg-blue-500/10 px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 flex items-center justify-center space-x-2"
              >
                <FileText className="w-5 h-5" />
                <span>{t('viewDocs')}</span>
              </button>
            </div>
          </div>

          {/* Terminal Demo */}
          <div className="bg-slate-800 rounded-lg p-6 max-w-2xl mx-auto font-mono text-left">
            <div className="flex items-center mb-4">
              <div className="flex space-x-2">
                <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                <div className="w-3 h-3 bg-green-500 rounded-full"></div>
              </div>
              <span className="ml-4 text-sm text-gray-400">AI Nextus Terminal</span>
            </div>
            <div className="text-green-400 text-sm">
              <div className="mb-2">$ docker run -p 8080:8080 ainextus/yolo:latest</div>
              <div className="mb-2 text-gray-300">🚀 YOLOv8 model loading...</div>
              <div className="mb-2 text-gray-300">✅ API server running on port 8080</div>
              <div className="text-blue-400">$ curl -X POST http://localhost:8080/run/yolo</div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <ChevronDown className="w-8 h-8 text-gray-400" />
        </div>
      </section>

      {/* Problem & Solution */}
      <section id="solution" className="py-20 bg-slate-800/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              {t('problem')} & <span className="text-blue-400">{t('solutionTitle')}</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Problem */}
            <div className="bg-red-900/20 border border-red-500/30 rounded-2xl p-8">
              <h3 className="text-2xl font-bold mb-6 text-red-400">{t('problems')}</h3>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-red-500 rounded-full mt-2"></div>
                  <p className="text-gray-300">{t('problem1')}</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-red-500 rounded-full mt-2"></div>
                  <p className="text-gray-300">{t('problem2')}</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-red-500 rounded-full mt-2"></div>
                  <p className="text-gray-300">{t('problem3')}</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-red-500 rounded-full mt-2"></div>
                  <p className="text-gray-300">{t('problem4')}</p>
                </div>
              </div>
            </div>

            {/* Solution */}
            <div className="bg-green-900/20 border border-green-500/30 rounded-2xl p-8">
              <h3 className="text-2xl font-bold mb-6 text-green-400">{t('solutionTitle')}</h3>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <CheckCircle className="w-5 h-5 text-green-400 mt-0.5" />
                  <p className="text-gray-300">{t('solution1')}</p>
                </div>
                <div className="flex items-start space-x-3">
                  <CheckCircle className="w-5 h-5 text-green-400 mt-0.5" />
                  <p className="text-gray-300">{t('solution2')}</p>
                </div>
                <div className="flex items-start space-x-3">
                  <CheckCircle className="w-5 h-5 text-green-400 mt-0.5" />
                  <p className="text-gray-300">{t('solution3')}</p>
                </div>
                <div className="flex items-start space-x-3">
                  <CheckCircle className="w-5 h-5 text-green-400 mt-0.5" />
                  <p className="text-gray-300">{t('solution4')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How it Works */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              {t('howIt')} <span className="text-blue-400">{t('works')}</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              {
                step: "1",
                title: t('downloadModel'),
                description: t('downloadDescription'),
                icon: <Download className="w-8 h-8" />
              },
              {
                step: "2", 
                title: t('apiConnect'),
                description: t('apiConnectDescription'),
                icon: <Shield className="w-8 h-8" />
              },
              {
                step: "3",
                title: t('sendRequest'),
                description: t('sendRequestDescription'),
                icon: <Code className="w-8 h-8" />
              },
              {
                step: "4",
                title: t('receiveResponse'),
                description: t('receiveResponseDescription'),
                icon: <Server className="w-8 h-8" />
              }
            ].map((item, index) => (
              <div key={index} className="relative">
                <div className="bg-slate-800 border border-blue-500/30 rounded-2xl p-6 text-center">
                  <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    {item.icon}
                  </div>
                  <div className="text-2xl font-bold text-blue-400 mb-2">{item.step}</div>
                  <h3 className="text-lg font-semibold mb-2">{item.title}</h3>
                  <p className="text-gray-300 text-sm">{item.description}</p>
                </div>
                {index < 3 && (
                  <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2">
                    <ArrowRight className="w-6 h-6 text-blue-400" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Dashboard Preview */}
      <section id="preview" className="py-20 bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="inline-block bg-blue-600/20 text-blue-400 text-sm font-semibold px-4 py-1.5 rounded-full mb-4 border border-blue-500/30">
              {t('demoInteractive')}
            </span>
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              {t('demoPreview')} <span className="text-blue-400">{t('demoPreviewHighlight')}</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              {t('demoPreviewDesc')}
            </p>
            <p className="text-sm text-gray-500 mt-3">{t('demoTabHint')}</p>
          </div>
          <DashboardPreview />
        </div>
      </section>

      {/* Supported Models */}
      <section id="models" className="py-20 bg-slate-800/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              {t('supportedModels')} <span className="text-blue-400">{t('models')}</span>
            </h2>
             <p className="text-xl md:text-2xl mb-8 text-gray-300 max-w-4xl mx-auto">
              {t('modelsNote')}
            </p>
          </div>
          
          <div className="overflow-x-auto">
            <table className="w-full bg-slate-800 rounded-2xl overflow-hidden">
              <thead className="bg-slate-700">
                <tr>
                  <th className="px-6 py-4 text-left text-blue-400 font-semibold">{t('category')}</th>
                  <th className="px-6 py-4 text-left text-blue-400 font-semibold">{t('model')}</th>
                  <th className="px-6 py-4 text-left text-blue-400 font-semibold">{t('description')}</th>
                  <th className="px-6 py-4 text-left text-blue-400 font-semibold">{t('status')}</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-700">
                {[
                  { category: t('vision'), model: "YOLOv8", description: t('objectDetection'), status: "✅" },
                  { category: t('segmentation'), model: "SAM", description: t('segmentAnything'), status: "✅" },
                  { category: t('nlp'), model: "LLaMA", description: t('chatGeneration'), status: "✅" },
                  { category: t('audio'), model: "Whisper", description: t('speechRecognition'), status: "🔜" },
                  { category: t('multimodal'), model: "CLIP", description: t('imageTextMatching'), status: "🔜" },
                  { category: "OCR", model: "Tesseract", description: t('ocr'), status: "🔜" }
                ].map((item, index) => (
                  <tr key={index} className="hover:bg-slate-700/50 transition-colors">
                    <td className="px-6 py-4 text-gray-300">{item.category}</td>
                    <td className="px-6 py-4 font-mono text-cyan-400">{item.model}</td>
                    <td className="px-6 py-4 text-gray-300">{item.description}</td>
                    <td className="px-6 py-4 text-2xl">{item.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* API Section */}
      <section id="api" className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              {t('developerApis')} <span className="text-blue-400">{t('apis')}</span>
            </h2>
            <p className="text-xl text-gray-300">{t('developerDescription')}</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Request */}
            <div className="bg-slate-800 rounded-2xl overflow-hidden">
              <div className="bg-slate-700 px-6 py-4 flex items-center justify-between">
                <h3 className="text-lg font-semibold text-green-400">{t('request')}</h3>
                <button 
                  onClick={() => copyToClipboard(apiExample, 'request')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  {copiedCode === 'request' ? <CheckCircle className="w-5 h-5" /> : <Copy className="w-5 h-5" />}
                </button>
              </div>
              <pre className="p-6 text-sm text-gray-300 overflow-x-auto">
                <code>{apiExample}</code>
              </pre>
            </div>

            {/* Response */}
            <div className="bg-slate-800 rounded-2xl overflow-hidden">
              <div className="bg-slate-700 px-6 py-4 flex items-center justify-between">
                <h3 className="text-lg font-semibold text-blue-400">{t('response')}</h3>
                <button 
                  onClick={() => copyToClipboard(responseExample, 'response')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  {copiedCode === 'response' ? <CheckCircle className="w-5 h-5" /> : <Copy className="w-5 h-5" />}
                </button>
              </div>
              <pre className="p-6 text-sm text-gray-300 overflow-x-auto">
                <code>{responseExample}</code>
              </pre>
            </div>
          </div>


          {/* Örnek kodlar butonu */}

          {/*<div className="mt-8 text-center">
            <p className="text-gray-300 mb-4">{t('exampleDocs')}</p>
            <div className="flex flex-wrap gap-4 justify-center">
              <button className="bg-yellow-600 hover:bg-yellow-700 px-6 py-3 rounded-lg font-semibold transition-colors">
                Python SDK
              </button>
              <button className="bg-green-600 hover:bg-green-700 px-6 py-3 rounded-lg font-semibold transition-colors">
                Node.js SDK
              </button>
              <button className="bg-blue-600 hover:bg-blue-700 px-6 py-3 rounded-lg font-semibold transition-colors">
                C++ SDK
              </button>
            </div>
          </div>*/}


        </div>
      </section>

      {/* Target Audience */}
      <section className="py-20 bg-slate-800/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              {t('forWhom')} <span className="text-blue-400">{t('whom')}</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: t('enterpriseTeams'),
                description: t('enterpriseDescription'),
                icon: "🏢"
              },
              {
                title: t('rnd'),
                description: t('rndDescription'),
                icon: "🔬"
              },
              {
                title: t('startups'),
                description: t('startupDescription'),
                icon: "🚀"
              },
              {
                title: t('iot'),
                description: t('iotDescription'),
                icon: "🤖"
              },
              {
                title: t('universities'),
                description: t('universityDescription'),
                icon: "🎓"
              },
              {
                title: t('dataScientists'),
                description: t('dataDescription'),
                icon: "📊"
              }
            ].map((item, index) => (
              <div key={index} className="bg-slate-800 border border-blue-500/30 rounded-2xl p-6 text-center hover:border-blue-500/60 transition-colors">
                <div className="text-4xl mb-4">{item.icon}</div>
                <h3 className="text-lg font-semibold mb-2">{item.title}</h3>
                <p className="text-gray-300 text-sm">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Advantages */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              {t('why')} <span className="text-blue-400">{t('trust')}</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: <Globe className="w-8 h-8" />,
                title: t('platformIndependent'),
                description: t('platformIndependentDesc')
              },
              {
                icon: <Shield className="w-8 h-8" />,
                title: t('secure'),
                description: t('secureDesc')
              },
              {
                icon: <Server className="w-8 h-8" />,
                title: t('dockerBased'),
                description: t('dockerBasedDesc')
              },
              {
                icon: <FileText className="w-8 h-8" />,
                title: t('versionControl'),
                description: t('versionControlDesc')
              },
              {
                icon: <Code className="w-8 h-8" />,
                title: t('extensible'),
                description: t('extensibleDesc')
              },
              {
                icon: <Users className="w-8 h-8" />,
                title: t('community'),
                description: t('communityDesc')
              }
            ].map((item, index) => (
              <div key={index} className="bg-slate-800 border border-blue-500/30 rounded-2xl p-6 hover:border-blue-500/60 transition-all duration-300 transform hover:-translate-y-1">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full flex items-center justify-center mb-4">
                  {item.icon}
                </div>
                <h3 className="text-lg font-semibold mb-2">{item.title}</h3>
                <p className="text-gray-300 text-sm">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Roadmap */}
      <section className="py-20 bg-slate-800/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              {t('road')} <span className="text-blue-400">{t('map')}</span>
            </h2>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full bg-slate-800 rounded-2xl overflow-hidden">
              <thead className="bg-slate-700">
                <tr>
                  <th className="px-6 py-4 text-left text-blue-400 font-semibold">{t('stage')}</th>
                  <th className="px-6 py-4 text-left text-blue-400 font-semibold">{t('state')}</th>
                  <th className="px-6 py-4 text-left text-blue-400 font-semibold">{t('content')}</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-700">
                {[
                  { phase: "MVP", status: "✅", content: "LLaMA, YOLO, Whisper & REST API" },
                  { phase: t('panel'), status: "🔜", content: t('panelDesc')},
                  { phase: t('communityUpload'), status: "🔜", content: t('communityUploadDesc') },
                  { phase: t('marketplace'), status: "🔜", content: t('marketplaceDesc') },
                  { phase: t('cloud'), status: "🔜", content: t('cloudDesc') }
                ].map((item, index) => (
                  <tr key={index} className="hover:bg-slate-700/50 transition-colors">
                    <td className="px-6 py-4 font-semibold text-cyan-400">{item.phase}</td>
                    <td className="px-6 py-4 text-2xl">{item.status}</td>
                    <td className="px-6 py-4 text-gray-300">{item.content}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            {t('demoContact')} <span className="text-blue-400">{t('contact')}</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            {t('demoContactDesc')}
          </p>
        </div>
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <h3 className="text-2xl font-bold text-gray-200 mb-6">{t('contactUs')}</h3>
              <div className="space-y-6">
                {[
                  { icon: <Mail className="w-6 h-6" />, label: "E-posta", value: "info@ainextus.com" },
                ].map((item, index) => (
                  <div key={index} className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center text-blue-600">
                      {item.icon}
                    </div>
                    <div className='text-xl'>
                      <p className="font-semibold text-gray-300">{item.label}</p>
                      <p className="text-gray-400">{item.value}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            <form onSubmit={handleSubmit} className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-8">
              <div className="space-y-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    {t('fullName')}
                  </label>
                  <input 
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all text-gray-700 mb-2"
                    placeholder={t('enterName')}
                    required
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    {t('email')}
                  </label>
                  <input 
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all text-gray-700 mb-2"
                    placeholder={t('enterEmail')}
                    required
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    {t('message')}
                  </label>
                  <textarea 
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    rows="4"
                    className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all resize-none text-gray-700 mb-2"
                    placeholder={t('enterMessage')}
                    required
                  ></textarea>
                </div>
                
                <button 
                  type="submit"
                  disabled={isLoading}
                  className="w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white py-3 rounded-xl font-semibold hover:from-blue-600 hover:to-blue-700 transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center gap-2"
                >
                  {isLoading ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                      Gönderiliyor...
                    </>
                  ) : (
                    <>
                      <Send className="w-4 h-4" />
                      {t('sendMessage')}
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>


      {/* Footer */}
      <footer className="py-12 bg-gray-900 text-white">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="flex items-center space-x-3 mb-4 md:mb-0">
              <div className="w-10 h-10 from-blue-500 to-blue-600 rounded-lg flex items-center justify-center">
                <img src={logo} alt="AI Nextus" className="w-300 h-30" />
              </div>
              <span className="text-xl font-bold">AI Nextus</span>
            </div>
            
            {/* Social Media in Footer */}
        <div className="flex items-center space-x-4 mb-4 md:mb-0">
          {[
            {
              icon: <Linkedin className="w-8 h-8" />,
              label: "LinkedIn",
              color: "hover:text-blue-400",
              url: "https://www.linkedin.com/company/ainextus",
            },
          ].map((social, index) => (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`w-10 h-10 rounded-lg bg-gray-800 flex items-center justify-center text-gray-400 transition-all duration-300 transform hover:scale-110 ${social.color}`}
              title={social.label}
            >
              {social.icon}
            </a>
          ))}
        </div>

            
            <p className="text-gray-400 text-center md:text-right">
              © 2025 AiNextus. {t('allRightsReserved')}
            </p>
          </div>
        </div>
      </footer>

    </div>
  );
}